import { render, staticRenderFns } from "./PendingCaptains.vue?vue&type=template&id=fa04f97e&scoped=true"
import script from "./PendingCaptains.vue?vue&type=script&lang=js"
export * from "./PendingCaptains.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa04f97e",
  null
  
)

export default component.exports